import {
  Button,
  DataGrid,
  ScrollView,
  Popup,
  Form,
  SelectBox,
  NumberBox,
  TextBox,
} from "devextreme-react";
import {
  Column,
  ColumnChooser,
  Export,
  FilterRow,
  HeaderFilter,
  Paging,
} from "devextreme-react/data-grid";
import React, { useEffect, useState, useMemo } from "react";
import { articulos, empresa, tipo } from "./data_test";
import { GroupItem, Item, Label } from "devextreme-react/form";

import * as DinamicQueries from "../../api/DinamicsQuery";
import * as ReportsService from "../../api/reports";

const InventarioPage = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [dataForm, setDataForm] = useState({
    tipo_movimiento: "",
    no_factura: "",
    empresa: "",
    region: "",
    cuenta_dotar: "",
    responsable: "",
    beneficiado: "",
    cedula_beneficiado: "",
    tipo_articulo: "",
    articulo: "",
    detalle_orden: [{ monto_unitario: 0, cantidad: 0, monto_total: 0 }],
  });
  const [regiones, setRegiones] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [inventario, setInventario] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [movInv, regiones, clientes, usuarios] = await Promise.all([
          ReportsService.getMovInventario(),
          ReportsService.getRegion(),
          ReportsService.getClients(),
          ReportsService.getUsers(),
        ]);
        setInventario(movInv.data.data);
        setRegiones(regiones.data);
        setClientes(clientes.data);
        setUsuarios(usuarios.data);
      } catch (error) {
        console.error("Error al cargar datos:", error);
      }
    };

    fetchData();
  }, []);

  const monto_total = useMemo(() => {
    const detalle_orden = dataForm.detalle_orden[0];
    return detalle_orden.monto_unitario * detalle_orden.cantidad;
  }, [
    dataForm.detalle_orden[0].monto_unitario,
    dataForm.detalle_orden[0].cantidad,
  ]);

  useEffect(() => {
    setDataForm((prevData) => ({
      ...prevData,
      detalle_orden: [{ ...prevData.detalle_orden[0], monto_total }],
    }));
  }, [monto_total]);

  const options = [
    { id: 1, name: "Entrada", value: "entrada" },
    { id: 2, name: "Dotacion", value: "dotacion" },
  ];

  const openPopup = () => {
    resetForm();
    setShowPopup(true);
  };

  const resetForm = () => {
    setDataForm({
      tipo_movimiento: "",
      no_factura: "",
      empresa: "",
      region: "",
      beneficiado: "",
      cedula_beneficiado: "",
      cuenta_dotar: "",
      responsable: "",
      tipo_articulo: "",
      articulo: "",
      detalle_orden: [{ monto_unitario: 0, cantidad: 0, monto_total: 0 }],
      cedula_empleado: "",
      cedula_responsable: "",
    });
  };
  const hidePopup = () => {
    resetForm(); // Primero resetea el formulario
    setShowPopup(false); // Luego cierra el popup
  };

  const handleSubmit = () => {
    const newMovimiento = { ...dataForm, id_movimiento: inventario.length + 1 };

    ReportsService.saveInventario(newMovimiento)
      .then((response) => {
        return ReportsService.getMovInventario();
      })
      .then((resp) => {
        setInventario(resp.data.data);
        resetForm();
        hidePopup();
      })
      .catch((error) => {
        console.error("Error al guardar inventario:", error);

        // Mostrar mensaje del backend si existe
        const mensaje =
          error?.response?.data?.msg ||
          "Error inesperado al guardar inventario";
        alert(mensaje);
      });
  };

  const responsableDisponible = useMemo(() => {
    return usuarios.filter(
      (usuario) =>
        (usuario.rol === "Supervisor" || usuario.rol === "Coordinador") &&
        usuario.region === dataForm.region
    );
  }, [usuarios, dataForm.region]);

  const beneficiadoDisponible = useMemo(() => {
    return usuarios.filter(
      (usuario) =>
        (usuario.rol === "Supervisor" ||
          usuario.rol === "Promotor" ||
          usuario.rol === "Transferencista") &&
        usuario.region === dataForm.region &&
        usuario.cliente === dataForm.cuenta_dotar
    );
  }, [usuarios, dataForm.region, dataForm.cuenta_dotar]);

  const isFormValid = () => {
    const {
      tipo_movimiento,
      empresa,
      region,
      responsable,
      cedula_responsable,
      tipo_articulo,
      articulo,
      detalle_orden,
      cuenta_dotar,
      cedula_beneficiado,
      no_factura,
    } = dataForm;

    const detalle = detalle_orden?.[0];

    if (
      !tipo_movimiento ||
      !empresa ||
      !region ||
      !responsable ||
      !cedula_responsable ||
      !tipo_articulo ||
      !articulo ||
      !detalle?.cantidad ||
      detalle.cantidad <= 0
    ) {
      return false;
    }

    if (tipo_movimiento === "entrada") {
      return (
        !!no_factura && !!detalle.monto_unitario && detalle.monto_unitario > 0
      );
    }

    if (tipo_movimiento === "dotacion") {
      return !!cuenta_dotar && !!cedula_beneficiado;
    }

    return true;
  };

  const renderContent = () => {
    return (
      <ScrollView height="100%" width="100%">
        <Form className="form-container" style={{ height: "100%" }}>
          <GroupItem
            colCount={
              !dataForm.tipo_movimiento
                ? 2
                : dataForm.tipo_movimiento === "dotacion"
                ? 2
                : 3
            }
          >
            <Item>
              <Label text="Tipo de Movimiento" />
              <SelectBox
                dataSource={options}
                valueExpr="value"
                displayExpr="name"
                value={dataForm.tipo_movimiento}
                onValueChanged={(e) => {
                  setDataForm({ ...dataForm, tipo_movimiento: e.value });
                }}
              />
            </Item>

            <Item>
              <Label>Número de Orden</Label>
              <NumberBox
                readOnly={true}
                value={inventario.length + 1}
                hoverStateEnabled={false}
              />
            </Item>

            {dataForm.tipo_movimiento === "entrada" && (
              <Item>
                <Label>Número de Factura</Label>
                <NumberBox
                  showClearButton={true}
                  value={dataForm.no_factura}
                  onValueChanged={(e) =>
                    setDataForm({ ...dataForm, no_factura: e.value })
                  }
                />
              </Item>
            )}
          </GroupItem>

          <GroupItem colCount={dataForm.tipo_movimiento === "dotacion" ? 3 : 2}>
            <Item>
              <Label text="Empresa" />
              <SelectBox
                dataSource={empresa}
                valueExpr="value"
                displayExpr="name"
                value={dataForm.empresa}
                onValueChanged={(e) =>
                  setDataForm({ ...dataForm, empresa: e.value })
                }
              />
            </Item>
            <Item>
              <Label text="Región" />
              <SelectBox
                searchEnabled={true}
                dataSource={regiones}
                valueExpr="nombre_region" // Ahora se usa el nombre como valor
                displayExpr="nombre_region" // Se sigue mostrando el nombre
                value={dataForm.region}
                onValueChanged={
                  (e) => setDataForm({ ...dataForm, region: e.value }) // Guarda el nombre de la región
                }
              />
            </Item>
            {dataForm.tipo_movimiento === "dotacion" && (
              <Item>
                <Label text="Cuenta a dotar" />
                <SelectBox
                  dataSource={clientes}
                  valueExpr="nombre_cliente"
                  displayExpr="nombre_cliente"
                  value={dataForm.cuenta_dotar}
                  onValueChanged={(e) =>
                    setDataForm({ ...dataForm, cuenta_dotar: e.value })
                  }
                />
              </Item>
            )}
          </GroupItem>
          <GroupItem colCount={2}>
            {/* Responsable */}
            <Item>
              <Label text="Responsable" />
              <SelectBox
                searchEnabled={true}
                dataSource={responsableDisponible}
                disabled={!dataForm.region} // Deshabilitar si no hay región seleccionada
                valueExpr="cedula" // Usar la cédula como identificador único
                displayExpr={
                  (item) => (item ? `${item.nombre} ${item.apellido}` : "") // Mostrar nombre y apellido
                }
                value={dataForm.cedula_responsable} // Vincular al estado con la cédula
                onValueChanged={(e) => {
                  const usuarioSeleccionado = usuarios.find(
                    (user) => user.cedula === e.value
                  );
                  setDataForm({
                    ...dataForm,
                    responsable: usuarioSeleccionado
                      ? `${usuarioSeleccionado.nombre} ${usuarioSeleccionado.apellido}`
                      : "", // Guarda el nombre completo del responsable
                    cedula_responsable: e.value, // Guarda la cédula asociada
                  });
                }}
              />
            </Item>

            <Item>
              <Label text="Cédula Responsable" />
              <TextBox
                value={dataForm.cedula_responsable}
                readOnly={true}
                hoverStateEnabled={false}
              />
            </Item>
          </GroupItem>
          {dataForm.tipo_movimiento === "dotacion" && (
            <GroupItem colCount={2}>
              <Item>
                <Label text="Beneficiado" />
                <SelectBox
                  searchEnabled={true}
                  dataSource={beneficiadoDisponible}
                  disabled={!dataForm.cuenta_dotar}
                  valueExpr="cedula" // Usar la cédula como identificador único
                  displayExpr={
                    (item) => (item ? `${item.nombre} ${item.apellido}` : "") // Mostrar nombre y apellido
                  }
                  value={dataForm.cedula_beneficiado} // Vincular al estado con la cédula
                  onValueChanged={(e) => {
                    const beneficiadoSeleccionado = usuarios.find(
                      (user) => user.cedula === e.value
                    );
                    setDataForm({
                      ...dataForm,
                      responsable: beneficiadoSeleccionado
                        ? `${beneficiadoSeleccionado.nombre} ${beneficiadoSeleccionado.apellido}`
                        : "", // Guarda el nombre completo del responsable
                      cedula_beneficiado: e.value, // Guarda la cédula asociada
                    });
                  }}
                />
              </Item>

              <Item>
                <Label text="Cédula Beneficiado" />
                <TextBox
                  value={dataForm.cedula_beneficiado}
                  readOnly={true}
                  hoverStateEnabled={false}
                />
              </Item>
            </GroupItem>
          )}

          <GroupItem colCount={dataForm.tipo_movimiento === "dotacion" ? 3 : 2}>
            <Item>
              <Label text="Tipo de artículo" />
              <SelectBox
                dataSource={tipo}
                valueExpr="value"
                displayExpr="name"
                value={dataForm.tipo_articulo}
                onValueChanged={(e) =>
                  setDataForm({ ...dataForm, tipo_articulo: e.value })
                }
              />
            </Item>
            <Item>
              <Label text="Artículos" />
              <SelectBox
                dataSource={articulos}
                valueExpr="value"
                displayExpr="name"
                value={dataForm.articulo}
                onValueChanged={(e) =>
                  setDataForm({ ...dataForm, articulo: e.value })
                }
              />
            </Item>
            {dataForm.tipo_movimiento === "dotacion" && (
              <Item>
                <Label>Cantidad</Label>
                <NumberBox
                  showClearButton={true}
                  value={dataForm.detalle_orden[0].cantidad} // Se asigna el valor actual
                  onValueChanged={(e) =>
                    setDataForm({
                      ...dataForm,
                      detalle_orden: [
                        {
                          ...dataForm.detalle_orden[0],
                          cantidad: e.value || 0,
                        },
                      ],
                    })
                  }
                />
              </Item>
            )}
          </GroupItem>
          {dataForm.tipo_movimiento === "entrada" && (
            <GroupItem colCount={3}>
              <Item>
                <Label>Monto Unitario</Label>
                <NumberBox
                  showClearButton={true}
                  value={dataForm.detalle_orden[0].monto_unitario} // Se asigna el valor actual
                  onValueChanged={(e) =>
                    setDataForm({
                      ...dataForm,
                      detalle_orden: [
                        {
                          ...dataForm.detalle_orden[0],
                          monto_unitario: e.value || 0,
                        },
                      ],
                    })
                  }
                />
              </Item>

              <Item>
                <Label>Cantidad</Label>
                <NumberBox
                  showClearButton={true}
                  value={dataForm.detalle_orden[0].cantidad} // Se asigna el valor actual
                  onValueChanged={(e) =>
                    setDataForm({
                      ...dataForm,
                      detalle_orden: [
                        {
                          ...dataForm.detalle_orden[0],
                          cantidad: e.value || 0,
                        },
                      ],
                    })
                  }
                />
              </Item>

              <Item>
                <Label>Total</Label>
                <NumberBox
                  showClearButton={true}
                  readOnly={true}
                  value={dataForm.detalle_orden[0].monto_total}
                />
              </Item>
            </GroupItem>
          )}
        </Form>
      </ScrollView>
    );
  };

  return (
    <div>
      <div className="d-flex gap-2 mt-3">
        <Button className="btn btn-primary" onClick={openPopup}>
          Añadir Movimiento
        </Button>
      </div>

      <DataGrid
        className="tabla-Cliente"
        dataSource={inventario} // Evita errores si inventario es null o undefined
        showBorders={true}
        remoteOperations={true}
        focusedRowEnabled={true}
        style={{ height: "430px", width: "100%" }}
        keyExpr="id"
        wordWrapEnabled={true}
      >
        <Export enabled={true} />
        <ColumnChooser enabled={true} mode="select" />
        <FilterRow visible={true} />
        <Paging defaultPageSize={12} />
        <HeaderFilter visible={true} />
        <Column
          width={120}
          caption="Número de Orden"
          dataField="id_movimiento"
          dataType="string"
        />
        <Column
          width={120}
          caption="Tipo de Movimiento"
          dataField="tipo_movimiento"
          dataType="string"
        />

        <Column
          width={120}
          caption="Número de Factura"
          dataField="no_factura"
          dataType="string"
          cellRender={(data) => Number(data.value) || ""}
        />

        <Column
          width={100}
          caption="Cantidad"
          dataField="detalle_orden"
          cellRender={(data) =>
            Array.isArray(data.value) && data.value[0]?.cantidad !== undefined
              ? data.value[0].cantidad
              : "Sin cantidad"
          }
        />

        <Column
          width={100}
          caption="Total ($)"
          dataField="detalle_orden"
          cellRender={(data) => {
            const monto = data.value?.[0]?.monto_total;
            return monto && monto !== 0 ? `$${monto}` : "";
          }}
        />

        <Column
          width={200}
          caption="Empresa"
          dataField="empresa"
          dataType="string"
        />
        <Column
          width={140}
          caption="Región"
          dataField="region"
          dataType="string"
        />
        <Column
          width={200}
          caption="Cuenta a dotar"
          dataField="cuenta_dotar"
          dataType="string"
        />
        <Column
          width={150}
          caption="Responsable"
          dataField="responsable"
          dataType="string"
        />
        <Column
          width={150}
          caption="Cedula Empleado"
          dataField="cedula_responsable"
          dataType="number"
        />
        <Column
          width={150}
          caption="Tipo Artículo"
          dataField="tipo_articulo"
          dataType="string"
        />
        <Column
          width={150}
          caption="Artículo"
          dataField="articulo"
          dataType="string"
        />
        <Column
          width={150}
          caption="Fecha Creación"
          dataField="fecha_creacion"
          cellRender={(data) =>
            data.value
              ? new Date(data.value._seconds * 1000).toLocaleDateString()
              : ""
          }
        />
      </DataGrid>

      <Popup
        width={"80%"}
        height={"85%"}
        visible={showPopup}
        onHiding={hidePopup}
        showCloseButton={true}
        contentRender={renderContent}
        toolbarItems={[
          {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: {
              text: "Guardar",
              onClick: handleSubmit,
              disabled: !isFormValid(), // 👈 aquí lo conectamos
            },
          },
          {
            widget: "dxButton",
            toolbar: "bottom",
            location: "after",
            options: {
              text: "Cancelar",
              onClick: hidePopup,
            },
          },
        ]}
      />
    </div>
  );
};

export default InventarioPage;
